import { getStorage } from 'firebase/storage';
import { app as firebaseApp } from '.';

export const storage = getStorage(firebaseApp);
